import { DeviceSettingsFeatureToggle } from 'src/app/enums/feature-toggle.enum';
import { LocalStorageKey } from 'src/app/enums/local-storage-key.enum';
import { FeatureToggleService } from 'src/app/services/feature-toggle/feature-toggle.service';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { CommonService } from 'src/app/services/common/common.service';
import { PowerService } from 'src/app/services/power/power.service';
import { Injectable } from '@angular/core';
@Injectable({
	providedIn: 'root'
})
export class EnergyStar {

	constructor(
		private featureToggle: FeatureToggleService,
		private logger: LoggerService,
		private storage: CommonService,
		private powerService: PowerService,
	) {}

	public getFromCache(): boolean {
		const cache = this.storage.getLocalStorageValue(LocalStorageKey.EnergyStarCapability, undefined);
		if (cache !== undefined) {
			return cache;
		}

		return false;
	}

	public getFeatureToggle(): boolean {
		return this.featureToggle.isDeviceSettingsFeatureAvailable(DeviceSettingsFeatureToggle.EnergyStar);
	}

	public async getCapability(): Promise<any> {
		this.logger.info('Before getEnergyStarCapability', {});
		return this.powerService.getEnergyStarCapability()
			.then((isEnergyStarProduct: boolean) => {
				this.logger.info('getEnergyStarCapability.then', isEnergyStarProduct);
				this.storage.setLocalStorageValue(LocalStorageKey.EnergyStarCapability, isEnergyStarProduct);
				return isEnergyStarProduct;
			}).catch(error => {
				this.logger.error('getEnergyStarCapability.error', error.message);
			});
	};
}
